import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class GamificationService {

  constructor(private http: HttpClient) { }

  public getGamificationData(id: number): Observable<any> {
    return this.http.get(`${environment.envVar.API_URL}/company/${id}/settings/gamification`).pipe(
      map((data) => data)
    );
  }

  public updateGamificationData(id: number, params: any): Observable<any> {
    return this.http.put(`${environment.envVar.API_URL}/company/${id}/settings/gamification`, { params }).pipe(
      map((data) => data)
    );
  }

  public getFullData(): any {
    return {
      "title": "words-gamification.welcome",
      "description": "words-gamification.description",
      "enabled": false,
      "pointsSection": {
        "title": "words-gamification.point_section_title",
        "description": "words-gamification.point_section_description",
        "dailyLoginSection": {
          "title": "words-gamification.daily_login",
          "settings": [
            {
              "label": "words-gamification.points_label",
              "value": 5,
              "type": "number",
              "step": 1,
              "min": 1,
              "required": true
            },
            {
              "label": "words-gamification.status_label",
              "value": true,
              "type": "checkbox"
            }
          ]
        },
        "subscribeToCourseSection": {
          "title": "words-gamification.subscribe_to_course",
          "settings": [
            {
              "label": "words-gamification.points_label",
              "value": 20,
              "type": "number",
              "step": 1,
              "min": 1,
              "required": true
            },
            {
              "label": "words-gamification.status_label",
              "value": true,
              "type": "checkbox"
            }
          ]
        },
        "subscribeToExternalContentSection": {
          "title": "words-gamification.subscribe_to_external_content",
          "settings": [
            {
              "label": "words-gamification.points_label",
              "value": 15,
              "type": "number",
              "step": 1,
              "min": 1,
              "required": true
            },
            {
              "label": "words-gamification.status_label",
              "value": true,
              "type": "checkbox"
            }
          ]
        },
        "subscribeToTrajectSection": {
          "title": "words-gamification.subscribe_to_traject",
          "settings": [
            {
              "label": "words-gamification.points_label",
              "value": 25,
              "type": "number",
              "step": 1,
              "min": 1,
              "required": true
            },
            {
              "label": "words-gamification.status_label",
              "value": true,
              "type": "checkbox"
            }
          ]
        },
        "completeCourseSection": {
          "title": "words-gamification.complete_course",
          "settings": [
            {
              "label": "words-gamification.points_label",
              "value": 50,
              "type": "number",
              "step": 1,
              "min": 1,
              "required": true
            },
            {
              "label": "words-gamification.status_label",
              "value": true,
              "type": "checkbox"
            }
          ]
        },
        "completeExternalContentSection": {
          "title": "words-gamification.complete_external_content",
          "settings": [
            {
              "label": "words-gamification.points_label",
              "value": 40,
              "type": "number",
              "step": 1,
              "min": 1,
              "required": true
            },
            {
              "label": "words-gamification.status_label",
              "value": true,
              "type": "checkbox"
            }
          ]
        },
        "completeTrajectSection": {
          "title": "words-gamification.complete_traject",
          "settings": [
            {
              "label": "words-gamification.points_label",
              "value": 60,
              "type": "number",
              "step": 1,
              "min": 1,
              "required": true
            },
            {
              "label": "words-gamification.status_label",
              "value": true,
              "type": "checkbox"
            }
          ]
        },
        "rateContentSection": {
          "title": "words-gamification.rate_content",
          "settings": [
            {
              "label": "words-gamification.points_label",
              "value": 10,
              "type": "number",
              "step": 1,
              "min": 1,
              "required": true
            },
            {
              "label": "words-gamification.status_label",
              "value": true,
              "type": "checkbox"
            }
          ]
        },
        "shareContentSection": {
          "title": "words-gamification.share_content",
          "settings": [
            {
              "label": "words-gamification.points_label",
              "value": 10,
              "type": "number",
              "step": 1,
              "min": 1,
              "required": true
            },
            {
              "label": "words-gamification.status_label",
              "value": true,
              "type": "checkbox"
            }
          ]
        },
        "commentRatedContentSection": {
          "title": "words-gamification.comment_rated_content",
          "settings": [
            {
              "label": "words-gamification.points_label",
              "value": 15,
              "type": "number",
              "step": 1,
              "required": true
            },
            {
              "label": "words-gamification.status_label",
              "value": true,
              "type": "checkbox"
            }
          ]
        }
      },
      "badgesSection": {
        "title": "words-gamification.badges_section_title",
        "description": "words-gamification.badges_section_description",
        "selectedPackPath": "1",
        "required": true,
        "badges": [
          {
            "title": "words-gamification.label_badge_pack_one",
            "path": "pack-01",
            "settings": [
              {
                "tooltip": "words-gamification.badge_one",
                "value": "words-gamification.badge_one",
                "type": "radio"
              }
            ],
            "number": 1
          },
          {
            "title": "words-gamification.label_badge_pack_two",
            "path": "pack-02",
            "settings": [
              {
                "tooltip": "words-gamification.badge_two",
                "value": "words-gamification.badge_two",
                "type": "radio"
              }
            ],
            "number": 2
          },
          {
            "title": "words-gamification.label_badge_pack_three",
            "path": "pack-03",
            "settings": [
              {
                "tooltip": "words-gamification.badge_three",
                "value": "words-gamification.badge_three",
                "type": "radio"
              }
            ],
            "number": 3
          },
          {
            "title": "words-gamification.label_badge_pack_four",
            "path": "pack-04",
            "settings": [
              {
                "tooltip": "words-gamification.badge_four",
                "value": "words-gamification.badge_four",
                "type": "radio"
              }
            ],
            "number": 4
          }
        ]
      },
      "gamificationLevelsSection": {
        "title": "words-gamification.levels_section_title",
        "levels": [
        {
          "title": "words-gamification.label_level_one",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_one", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 0, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 1, "type": "select", "required": true }
          ],
          "number": 1,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_two",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_two", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 150, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 2, "type": "select", "required": true }
          ],
          "number": 2,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_three",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_three", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 400, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 3, "type": "select", "required": true }
          ],
          "number": 3,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_four",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_four", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 800, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 4, "type": "select", "required": true }
          ],
          "number": 4,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_five",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_five", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 1300, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 5, "type": "select", "required": true }
          ],
          "number": 5,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_six",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_six", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 1900, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 6, "type": "select", "required": true }
          ],
          "number": 6,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_seven",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_seven", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 2700, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 7, "type": "select", "required": true }
          ],
          "number": 7,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_eight",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_eight", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 3700, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 8, "type": "select", "required": true }
          ],
          "number": 8,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_nine",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_nine", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 5000, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 9, "type": "select", "required": true }
          ],
          "number": 9,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_ten",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_ten", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 6600, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 10, "type": "select", "required": true }
          ],
          "number": 10,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_eleven",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_eleven", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 8500, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 11, "type": "select", "required": true }
          ],
          "number": 11,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_twelve",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_twelve", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 10700, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 12, "type": "select", "required": true }
          ],
          "number": 12,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_thirteen",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_thirteen", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 13200, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 13, "type": "select", "required": true }
          ],
          "number": 13,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_fourteen",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_fourteen", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 16000, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 14, "type": "select", "required": true }
          ],
          "number": 14,
          "canDelete": false
        },
        {
          "title": "words-gamification.label_level_fifteen",
          "settings": [
            { "placeholder": "words-gamification.placeholder_level", "value": "words-gamification.level_fifteen", "type": "text", "required": true },
            { "placeholder": "words-gamification.required_experience_points", "value": 20000, "type": "number", "step": 1, "required": true },
            { "placeholder": "words-gamification.reward_badge", "selected": 15, "type": "select", "required": true }
          ],
          "number": 15,
          "canDelete": false
        }
      ]
      }
    }
  };
}
